export default __webpack_public_path__ + "static/media/chuck_blue.d55df030.png";